module.exports = __webpack_public_path__ + "static/media/my.adf67c45.png";